const messages = {
  changeSalesRep: 'Change Sales Rep',
  selectOne: 'Select one',
  selectOption: 'Select a new sales rep and choose which orders to update:',
  update: 'Update',
  enqueuedTask:
    "Your orders are updating. You'll receive an email when updates are complete.",
  errorWhileUpdatingAllOrders: 'An error occurred while updating all orders.',
  updateAll: (ordersCount) => (
    <span>
      Update all <strong>{ordersCount}</strong> orders matching my current
      search/filters
    </span>
  ),
  updateAllWarning: (ordersCount) => (
    <span>
      <span>You are about to update the sales rep on</span>
      &nbsp;
      <strong>{ordersCount} orders</strong>
      &nbsp;
      <span>
        that match your current search and filters. This action cannot be
        undone.
      </span>
    </span>
  ),
  updateSelected: (ordersCount) => (
    <span>
      Update only my <strong>{ordersCount}</strong> selected orders
    </span>
  ),
}

export default messages
